import React from "react";

export function Card({ className, children }) {
  return <div className={`p-4 border rounded-lg shadow-md ${className}`}>{children}</div>;
}

export function CardContent({ className, children }) {
  return <div className={`mt-2 ${className}`}>{children}</div>;
}
